import { RootState } from 'store/rootReducer';

export const selectCharityById = (state: RootState, id: number) => state
  .organization.charities.data?.results.find((charity: { id: number | string; }) => charity.id === id);
